import { AuthUser } from "../../types/User/AuthUser";

export const applyRoleBasedFilters = (
  user: AuthUser,
  filterValues: any = {},
  setFilter: (filterName: string, value: string | undefined) => void,
  hasType: boolean = false,
  receivedFilters: any = undefined,
) => {
  if (receivedFilters?.county || (user?.role?.level?.id === 5 && user.county)) {
    setFilter(
      "CountyId",
      receivedFilters?.county?.id?.toString() ?? user?.county?.id?.toString(),
    );
    filterValues = {
      ...filterValues,
      CountyId: receivedFilters?.county?.id ?? user?.county?.id,
    };
  }
  if (
    receivedFilters?.province ||
    (user?.role?.level !== undefined &&
      user?.role?.level?.id >= 4 &&
      user.province)
  ) {
    setFilter(
      "ProvinceId",
      receivedFilters?.province?.id.toString() ?? user?.province?.id.toString(),
    );
    filterValues = {
      ...filterValues,
      ProvinceId: receivedFilters?.province?.id ?? user?.province?.id,
    };
    if (hasType) {
      setFilter(
        "IndicatorLevelId",
        receivedFilters?.indicatorLevel.id.toString() ||
          (user?.role?.level?.id === 4 ? "4" : "3"),
      );
      filterValues = {
        ...filterValues,
        IndicatorLevelId:
          (receivedFilters?.indicatorLevel?.id ?? user?.role?.level?.id === 4)
            ? 4
            : 3,
      };
    }
  }
  return filterValues;
};
